<template>
    <div>
        <Head :title="forms.name"/>
        <admin-ribbon v-if="false" :forms="forms"></admin-ribbon>
        <widget-frame :theme="theme" :forms="forms" :is-last="computedItems?.length === currentSlide"
                      :width="computedItems[currentSlide-1]?.width" @toggle-dark="darkMode = !darkMode" @reload-events="reloadCalendarDates">
            <template #sidebar>
                <div v-if="theme.logo_url" class="!w-[140px] md:!w-[180px] !max-h-[100px]"
                     :class="{ 'mb-4 lg:mb-8': showSidebar }">
                    <img :src="theme.logo_url" :alt="forms.name"
                         class="!w-[140px] md:!w-[180px] !max-h-[100px] object-contain"/>
                </div>
                <template v-if="showSidebar">
                    <widget-title v-if="forms.form_type.name !== 'service' || !selectingService.value" :forms="forms"
                                  :theme="theme"></widget-title>
                    <div class="max-md:hidden grow"></div>
                    <service-button v-if="false" @click="showChatWindow = !showChatWindow" :color="theme.color"
                                    :roundness="getRoundness()"
                                    title="AI Chat"
                                    icon="pi pi-sparkles" horizontal
                                    class="lg:mt-8 max-lg:absolute max-lg:w-[130px] max-lg:right-6 max-lg:top-6"></service-button>
                    <service-button @click="contactDialogModel = true" :color="theme.color" :roundness="getRoundness()"
                                    :title="$t('widget.contact')"
                                    icon="pi pi-envelope" horizontal only-icon-mobile
                                    class="lg:mt-4 max-lg:absolute max-md:w-auto max-lg:w-[130px] max-lg:right-6 max-lg:top-6"></service-button>
                    <contact-dialog v-model:visible="contactDialogModel" :url="`/send-contact-form-anonymous/${forms.slug}`" extended></contact-dialog>
                </template>
            </template>
            <template #bottombar>
                <div class="flex justify-end px-3 gap-2 items-center h-10">
                    <service-ribbon v-if="selectedService"
                                    :theme="theme"
                                    v-model:selectedService="selectedService"
                                    class="max-md:hidden"
                                    v-model:selectedWorker="selectedWorker"
                                    :roundness="roundness"></service-ribbon>

                    <rental-ribbon v-if="form.id_rental_items"
                                   :theme="theme"
                                   :selected-rental-item="_page.props.rentalItems?.find(item => item.id === form.id_rental_items)"
                                   :roundness="roundness"></rental-ribbon>
                    <div>
                        <div v-if="currentTimeSlotInformation" class="opacity-70 flex text-sm flex-col">
                            <p class="text-xs font-bold opacity-70 -mb-1">{{ $t('widget.selected_term') }}</p>
                            <p>{{ moment(selectedDay).format('DD.MM.Y') }}
                                od {{ currentTimeSlotInformation?.start }} do {{ currentTimeSlotInformation?.end }}</p>
                        </div>
                    </div>
                    <div class="grow"></div>
                    <price-ribbon
                        v-if="_page.props.rentalItems"
                        :theme="theme"
                        :form="form"
                        :start-time="currentTimeSlotInformation?.start"
                        :end-time="currentTimeSlotInformation?.end"
                        :selected-rental-item="_page.props.rentalItems?.find(item => item.id === form.id_rental_items)"
                    ></price-ribbon>
                    <Button
                        v-if="currentSlide > 1"
                        :class="[`!w-[37.5px] !border-neutral-300 dark:!border-neutral-700 !text-neutral-500 !h-[37.5px]`, roundness]"
                        icon="pi pi-arrow-left"
                        outlined
                        severity="contrast"
                        @click="currentSlide--"></Button>
                    <Button
                        v-if="!computedItems[currentSlide-1]?.hideNextButton"
                        :class="[`!bg-${theme.color}-500 !px-6 !py-2 !border-none hover:!bg-${theme.color}-600`, roundness]"
                        icon="pi pi-arrow-right"
                        icon-pos="right"
                        @click="goNext()"
                        :label="$t('widget.next')"></Button>
                </div>
            </template>
            <template #default>
                <Stepper v-model:value="currentSlide" :key="computedItems?.length" linear class="flex flex-col" :style="`--stepper-step-title-active-color: ${theme.color_html}; --stepper-separator-active-background: ${theme.color_html}; --stepper-step-number-active-color: ${theme.color_html}`">
                    <StepList class="!px-4 !mt-4 max-md:!hidden !overflow-x-hidden">
                        <Step v-for="(step, value) in computedItems" :value="value+1">
                            <span v-if="value === currentSlide || value === currentSlide -1"
                                  class="max-md:hidden">{{ $t(step.title) }}</span>
                        </Step>
                    </StepList>
                    <div class="relative grow w-full left-0 right-0">
                        <transition name="list-page" mode="out-in">
                            <div class="grow w-full top-0" :key="currentSlide">
                                <StepPanels class="grow relative">
                                    <StepPanel v-for="(step, value) in computedItems" :value="value+1" class="grow">
                                        <component v-if="step.component" :is="step.component" v-bind="step.bind"
                                                   :calendar-dates="availableCalendarDates"
                                                   :available-timeslots="availableTimeslots"
                                                   :calendar-key="calendarKey"
                                                   :timeslots-loading="timeslotsLoading"
                                                   v-model:valid="valid[`v_${currentSlide}`]"
                                                   v-model:form="form"
                                                   v-model:selectedDay="selectedDay"
                                                   v-model:selectedTimeSlot="selectedTimeSlot"
                                                   v-model:selectingService="selectingService"
                                                   v-model:selectedService="selectedService"
                                                   v-model:selectedWorker="selectedWorker"
                                                   v-model:currentSlide="currentSlide"
                                        ></component>
                                    </StepPanel>
                                </StepPanels>
                            </div>

                        </transition>
                    </div>
                </Stepper>
                <transition
                    enter-active-class="transition-transform duration-500 ease-out"
                    enter-from-class="translate-y-full opacity-0"
                    enter-to-class="translate-y-0 opacity-100"
                    leave-active-class="transition-transform duration-500 ease-in"
                    leave-from-class="translate-y-0 opacity-100"
                    leave-to-class="translate-y-full opacity-0"
                >
                    <diva-chat v-if="showChatWindow"
                               v-model:form="form"
                               :forms="forms"
                               :theme="theme"
                               v-model:show-chat-window="showChatWindow"
                               v-model:selectedDay="selectedDay"
                               v-model:selectedTimeSlot="selectedTimeSlot"
                               v-model:selectingService="selectingService"
                               v-model:selectedService="selectedService"
                               v-model:selectedWorker="selectedWorker"
                    ></diva-chat>
                </transition>
            </template>
        </widget-frame>
    </div>
</template>
<script setup>
import {Head, usePage} from '@inertiajs/vue3'
import {computed, markRaw, reactive, ref, watch} from "vue";
import moment from "moment/moment.js";
import _, {isInteger, uniq} from "lodash";
import {brightnessByColor} from "../../../helpers.js";
import AdminRibbon from "../components/ui-components/AdminRibbon.vue";
import WidgetFrame from "../../administration/components/ui-components/widget/WidgetFrame.vue";
import ServiceRibbon from "../../administration/components/ui-components/widget/ServiceRibbon.vue";
import WidgetTitle from "../../administration/components/ui-components/widget/WidgetTitle.vue";
import ServiceButton from "../components/ui-components/ServiceButton.vue";
import ContactDialog from "../components/ui-components/ContactDialog.vue";
import {Stepper, StepList, Step, StepPanels, StepPanel} from "primevue";
import RentalItemsWizardPage from "../components/wizard/RentalItemsWizardPage.vue";
import FormWizardPage from "../components/wizard/FormWizardPage.vue";
import TermsWizardPage from "../components/wizard/TermsWizardPage.vue";
import ServiceWizardPage from "../components/wizard/ServiceWizardPage.vue";
import Button from "primevue/button";
import RecapWizardPage from "../components/wizard/RecapWizardPage.vue";
import {useForm} from "laravel-precognition-vue-inertia";
import DateRangePickerWithPriceMap from "../components/wizard/DateRangePickerWithPriceMap.vue";
import RentalTermsWizardPage from "../components/wizard/RentalTermsWizardPage.vue";
import RentalRibbon from "../../administration/components/ui-components/widget/RentalRibbon.vue";
import AdditionalCostsWizardPage from "../components/wizard/AdditionalCostsWizardPage.vue";
import PriceRibbon from "../../administration/components/ui-components/widget/PriceRibbon.vue";
import DivaChat from "../components/view-components/DivaChat.vue";
import {useWindowSize} from "@vueuse/core";
import WorkerWizardPage from "../components/wizard/WorkerWizardPage.vue";
import useAvailability from "../composables/useAvailability.js";
import {DateTime} from "luxon";

const _page = usePage();
const availability = useAvailability();

const props = defineProps({
    forms: Object,
    events_workers: Object,
    registrationForm: Object
})

const form = useForm('POST', props.forms.url, {
    name: '',
    phone: '',
    email: '',
    note: '',
    day: '',
    day_start: '',
    day_end: '',
    timeslot: '',
    id_reservation_locations: null,
    id_reservation_workers: null,
    id_services: null,
    id_rental_items: null,
    additional_costs: [],
    gdpr_consent: false,
    formdata: {}
})

const needsWorkers = computed(() => {
    if (props.forms.form_type.name === 'service') {
        return selectedService.value?.workers.length
    }
    return false;
})

const canContinueToReservation = computed(() => {
    if (props.forms.form_type.name === 'service') {
        if (selectedService.value?.workers.length > 0) {
            return selectedWorker.value !== null
        }
        return selectedService.value !== null
    }
    return true;
})

const selectedService = ref(null);
const selectedWorker = ref(null);
const selectingService = ref(true);

const availableTimeslots = ref({});
const availableCalendarDates = ref([]);

const currentSlide = ref(1);

const today = new Date();
today.setHours(12, 0, 0);

const selectedDay = ref(today)
const selectedTimeSlot = ref(null)


const valid_days = (filteredValidDays) => {
    const hasCustomPlans = uniq(filteredValidDays.map(day => day.time_slots.map(time_slot => time_slot.id_reservation_workers)).flat()).filter(Boolean)

    if (selectedWorker.value) {
        const workerId = hasCustomPlans.includes(selectedWorker.value.id) ? selectedWorker.value.id : null;
        return filteredValidDays.filter(day => {
            return day.time_slots.filter(time_slot => time_slot.id_reservation_workers === workerId).length > 0
        });
    }

    return filteredValidDays;
}

const currentValidDays = computed(() => {
    const defaultDays = props.forms.valid_days;

    const defaultSlots = valid_days(defaultDays?.filter(day => day.valid_to === '2100-01-01'));
    const additionalSlots = defaultDays.filter(day => day.valid_to !== '2100-01-01');
    if (additionalSlots.length > 0) {
        const slots = valid_days(additionalSlots.filter((day) => {
            const start = moment(day.valid_from);
            const end = moment(day.valid_to);
            const now = moment(selectedDay.value);

            return now.isBetween(start, end);
        }));
        if (slots.length === 0)
            return defaultSlots;

        return slots;
    } else {
        return defaultSlots;
    }
})


const roundness = computed(() => {
    return {
        '!rounded-none': theme.value.roundness === 0,
        '!rounded-lg': theme.value.roundness === 1,
        '!rounded-xl': theme.value.roundness === 2,
        '!rounded-2xl': theme.value.roundness === 3,
    }
})

const getRoundness = () => {
    switch (theme.value.roundness) {
        case 0:
            return '!rounded-none';
        case 1:
            return '!rounded-lg';
        case 2:
            return '!rounded-xl';
        case 3:
            return '!rounded-2xl';
        default:
            return '';
    }
}

const showChatWindow = ref(false);

const currentTimeSlot = computed(() => {
    const week = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    if (selectedWorker.value) {
        const hasCustomPlans = uniq(currentValidDays.value.map(day => day.time_slots.map(time_slot => time_slot.id_reservation_workers)).flat()).filter(Boolean)
        const workerId = hasCustomPlans.includes(selectedWorker.value.id) ? selectedWorker.value.id : null;
        return currentValidDays.value.find((el) => el.name === week[selectedDay.value?.getDay()])?.time_slots.filter((slot) => slot.id_reservation_workers === workerId);
    }
    return currentValidDays.value.find((el) => el.name === week[selectedDay.value?.getDay()])?.time_slots;
})

const dateTimeRestrictions = ref(availability.formatDateTimeRestrictions(_page.props.dateTimeRestrictions));


const currentTimeSlotInformation = computed(() => {
    const timeslot = selectedTimeSlot.value;

    if (!isInteger(timeslot) && timeslot?.includes('/')) {
        const parts = timeslot.split('/');
        return {
            start: parts[0]?.substring(0, 5),
            end: parts[1]?.substring(0, 5)
        }
    }

    const ct = currentTimeSlot.value?.find(slot => slot.id === Number(timeslot));

    if (ct) {
        return {
            start: ct.time_start.substring(0, 5),
            end: ct.time_end.substring(0, 5)
        }
    }
})

const currentBrightness = ref(0);


const darkMode = ref(false);

const theme = computed({
    get() {
        if (darkMode.value) {
            return {
                color: props.forms.theme.color,
                borderless: props.forms.theme.borderless,
                transparent: props.forms.theme.transparent,
                darkMode: true,
                darkModeLock: props.forms.theme.darkModeLock,
                background_color: props.forms.theme.background_color_dark ?? props.forms.theme.background_color,
                background_image_url: props.forms.theme.background_image_url_dark ?? props.forms.theme.background_image_url,
                logo_url: props.forms.theme.logo_url_dark ?? props.forms.theme.logo_url,
                panel_color: props.forms.theme.panel_color_dark ?? props.forms.theme.panel_color,
                panel_transparency: props.forms.theme.panel_transparency_dark ?? props.forms.theme.panel_transparency,
                panel_backdrop_blur: props.forms.theme.panel_backdrop_blur_dark ?? props.forms.theme.panel_backdrop_blur,
                fontFamily: props.forms.theme.fontFamily,
                rows: props.forms.theme.rows,
                columns: props.forms.theme.columns,
                roundness: props.forms.theme.roundness,
                color_html: props.forms.theme.color_html
            }
        }
        return {
            color: props.forms.theme.color,
            borderless: props.forms.theme.borderless,
            transparent: props.forms.theme.transparent,
            darkMode: false,
            darkModeLock: props.forms.theme.darkModeLock,
            background_color: props.forms.theme.background_color,
            background_image_url: props.forms.theme.background_image_url,
            logo_url: props.forms.theme.logo_url,
            panel_color: props.forms.theme.panel_color,
            panel_transparency: props.forms.theme.panel_transparency,
            panel_backdrop_blur: props.forms.theme.panel_backdrop_blur,
            fontFamily: props.forms.theme.fontFamily,
            rows: props.forms.theme.rows,
            columns: props.forms.theme.columns,
            roundness: props.forms.theme.roundness,
            color_html: props.forms.theme.color_html
        }
    },
    set(val) {
        Object.assign(props.forms.theme, val);
    }
})
watch(() => theme.value.panel_color, _.debounce((val) => {
    currentBrightness.value = brightnessByColor(val)
}, 150), {immediate: true})

const contactDialogModel = ref(false);

watch(() => props.forms.theme.mode_lock, (val) => {

    if (val === 'auto') {
        if (!window.matchMedia) {
            return;
        }
        const query = window.matchMedia('(prefers-color-scheme: dark)');
        if (query.matches) {
            darkMode.value = true;
            document.querySelector('html')?.classList.add('dark');
        } else {
            darkMode.value = false;
            document.querySelector('html')?.classList.remove('dark');
        }
    } else {
        val === 'light' ? document.querySelector('html')?.classList.remove('dark') : document.querySelector('html')?.classList.add('dark');

        darkMode.value = val === 'dark';
    }
}, {immediate: true})

watch(darkMode, (val) => {
    val
        ? document.querySelector('html')?.classList.add('dark')
        : document.querySelector('html')?.classList.remove('dark');
})

const selectDay = (day) => {
    const date = DateTime.fromJSDate(day).toFormat('yyyy-MM-dd');
    availability.getTimeslots(props.forms, date, selectedWorker.value?.id, selectedService.value?.id).then((timeslots) => {
        availableTimeslots.value = timeslots;
    })
}

const timeslotsLoading = ref(false)
const calendarKey = ref(0)

const reloadCalendarDates = () => {
    timeslotsLoading.value = true
    availability.getCalendarDates(props.forms, selectedWorker.value?.id, selectedService.value?.id, true)
        .then((calendarDates) => {
            if (!calendarDates || calendarDates.status) return
            availableCalendarDates.value = calendarDates
            calendarKey.value++
            if (selectedDay.value) selectDay(selectedDay.value)
        })
        .finally(() => {
            timeslotsLoading.value = false
        })
}

watch(selectedWorker, (val) => {
    if (val) {
        availability.getDateTimeRestrictions(props.forms, val.id).then((restrictions) => {
            dateTimeRestrictions.value = restrictions;
            selectDay(selectedDay.value);
        });
    }
    availability.getCalendarDates(props.forms, val?.id, selectedService.value?.id).then((calendarDates) => {
        if (calendarDates.status || !calendarDates) {
            return;
        }
        availableCalendarDates.value = calendarDates;
    })
}, { immediate: true })

watch(selectedDay, (day) => {
    selectDay(day);
}, {immediate: true})

watch(selectedService, (val) => {
    selectDay(selectedDay.value)
})

const valid = ref({
    v_0: false,
    v_1: false,
    v_2: false,
    v_3: false,
    v_4: false,
    v_5: false,
});

const {width} = useWindowSize()

const showSidebar = computed(() => {
    if (width.value > 768)
        return true;

    return currentSlide.value === 1;
})

const computedItems = computed(() => {
    const current = bookingWorkflow[props.forms.form_type.name];
    return current.items.filter(item => {
        if (item.hideWhen === 'hideAdditionalCosts') {
            return _page.props.rentalItems?.find(item => item.id === form.id_rental_items)?.additional_costs.length !== 0
        }

        if (item.hideWhen === 'needsWorkers') {
            return needsWorkers.value
        }

        return true;
    });

})

const goNext = () => {
    const step = computedItems.value[currentSlide.value - 1]
    form.day = selectedDay.value ?? ''
    form.timeslot = selectedTimeSlot.value ?? ''
    form.id_reservation_workers = selectedWorker.value?.id ?? ''
    form.id_services = selectedService.value?.id ?? ''

    form.setErrors({});

    if (step.validate) {
        let validatable = step.validate;
        if (step.validateDynamic) {
            _page.props.formBuilder.forEach((field) => validatable.push('formdata.' + field.id))
        }

        axios.post(props.forms.url, form.data(), {
            headers: {
                'Precognition': 'true',
                'Precognition-Validate-Only': validatable.join(','),
            },
        }).catch(error => {
            form.setErrors(error.response.data.errors ?? {});
        }).then((response) => {
            if (response) {
                currentSlide.value++
            }
        });
    } else {
        currentSlide.value++
    }
}

const bookingWorkflow = reactive({
    service: {
        items: [
            {
                title: 'widget.service_chooser',
                component: markRaw(ServiceWizardPage),
                validate: [
                    'id_services',
                ],
                bind: {
                    canContinueToReservation: canContinueToReservation,
                    theme: theme,
                    forms: props.forms,
                    roundness: roundness,
                },
                width: 1118
            },
            {
                title: 'widget.worker_chooser',
                component: markRaw(WorkerWizardPage),
                validate: [
                    'id_reservation_workers',
                ],
                hideWhen: 'needsWorkers',
                bind: {
                    canContinueToReservation: canContinueToReservation,
                    theme: theme,
                    forms: props.forms,
                    roundness: roundness,
                },
                width: 1118
            },
            {
                title: 'widget.term',
                component: markRaw(TermsWizardPage),
                validate: [
                    'timeslot',
                    'day'
                ],
                bind: {
                    dateTimeRestrictions: dateTimeRestrictions,
                    theme: theme.value,
                    forms: props.forms,
                    currentBrightness: currentBrightness,
                    currentTimeSlot: currentTimeSlot,
                    availableTimeslots: availableTimeslots,
                    calendarDates: availableCalendarDates

                },
                width: 1118
            },
            {
                title: 'widget.reservation',
                component: markRaw(FormWizardPage),
                validate: [
                    'name',
                    'email',
                    'phone',
                    'id_reservation_locations',
                ],
                validateDynamic: true,
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            },
            {
                title: 'widget.recap',
                component: markRaw(RecapWizardPage),
                valid: ref(false),
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            }
        ]
    },
    personal: {
        items: [
            {
                title: 'widget.term',
                component: markRaw(TermsWizardPage),
                validate: [
                    'timeslot',
                    'day'
                ],
                valid: ref(false),
                bind: {
                    dateTimeRestrictions: dateTimeRestrictions,
                    theme: theme.value,
                    forms: props.forms,
                    currentBrightness: currentBrightness,
                    currentTimeSlot: currentTimeSlot,
                    availableTimeslots: availableTimeslots,
                    calendarDates: availableCalendarDates
                },
                width: 1118
            },
            {
                title: 'widget.reservation',
                component: markRaw(FormWizardPage),
                valid: ref(false),
                validate: [
                    'name',
                    'email',
                    'phone',
                    'id_reservation_locations',
                ],
                validateDynamic: true,
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            },
            {
                title: 'widget.recap',
                component: markRaw(RecapWizardPage),
                valid: ref(false),
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            }
        ]
    },
    rental: {
        items: [
            {
                title: 'widget.item_chooser',
                hideNextButton: true,
                component: markRaw(RentalItemsWizardPage),
                bind: {
                    items: _page.props.rentalItems,
                    theme: theme.value,
                    roundness: getRoundness()
                },
                width: 1500
            },
            {
                title: 'widget.additional_services',
                component: markRaw(AdditionalCostsWizardPage),
                hideWhen: 'hideAdditionalCosts',
                bind: {
                    items: _page.props.rentalItems,
                    theme: theme.value,
                    roundness: getRoundness()
                },
                width: 1200
            },
            {
                title: 'widget.term',
                component: markRaw(RentalTermsWizardPage),
                validate: ['day_start', 'day_end'],
                bind: {
                    theme: theme.value,
                    forms: props.forms,
                },
                width: 900
            },
            {
                title: 'widget.reservation',
                component: markRaw(FormWizardPage),
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            },
            {
                title: 'widget.recap',
                component: markRaw(RecapWizardPage),
                valid: ref(false),
                bind: {
                    locations: props.forms.reservation_locations,
                    theme: theme.value,
                    currentBrightness: currentBrightness,
                },
                width: 1118
            }
        ]
    }
})

bookingWorkflow.accommodation = bookingWorkflow.rental
</script>
<style scoped lang="scss">
.height-animate {
    height: calc-size(auto);
    transition: height .5s ease-in-out;

}
</style>
